import React from 'react';
import PropTypes from 'prop-types';
import enterprise from './enterprise.svg';
import individual from './individual.svg';
import { CURRENCY_SYMBOLS } from '../../constants';
import styled from 'styled-components';
import { formatPrice } from '../../utils';
import theme from '../../theme';

const planSignature = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  priceInCents: PropTypes.number.isRequired,
  billedMonthly: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.element.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired
};

const PlanCard = styled.div`
  text-align: center;
  margin: 20px;
  width: ${theme.cardWidth};
`;

const PlanFeature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 3px 0;
`;

const PlanPriceAmount = styled.span`
  // font-weight: 400;
  font-size: 24px;
`;

const PlanPricePerMonth = styled.span`
  // font-weight: 200;
  font-size: 18px;
`;

const PlanTitle = styled.div`
  font-weight: 300;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 20px;
`;



function PlanPrice(props) {

  const {plan} = props;
  const currencySymbol = CURRENCY_SYMBOLS[plan.currency];
  const price = formatPrice(plan.priceInCents);
  const maybePerMonth = plan.billedMonthly ? " / month" : null;
  return (
    <div>
      <PlanPriceAmount>
        {currencySymbol}{price}
      </PlanPriceAmount>
      <PlanPricePerMonth>
        {maybePerMonth}
      </PlanPricePerMonth>
    </div>
  )
}

export class Plan extends React.Component {

  render() {

    const {plan, button} = this.props;
    const features = [];
    plan.features.map(feature => features.push(
      <PlanFeature key={plan.features.indexOf(feature)}>
        {feature}
      </PlanFeature>
    ));
    return (
      <PlanCard className="pt-card pt-elevation-2">
        <PlanTitle>{plan.name}</PlanTitle>
        <div className="horizontal-divider"/>
        {plan.image}
        <div className="horizontal-divider"/>
        <PlanPrice plan={plan}/>
        <div className="horizontal-divider"/>
        {features}
        <div className="horizontal-divider"/>
        {button}
      </PlanCard>
    );
  }
}

Plan.propTypes = {
  plan: PropTypes.shape(planSignature).isRequired,
  button: PropTypes.element
};

Plan.defaultProps = {
  button: null
};

export const INDIVIDUAL_PLAN = {
  id: 'premium',
  name: 'Individual',
  currency: 'USD',
  priceInCents: 999,
  billedMonthly: true,
  description: '',
  image: <img src={individual} alt="individual"/>,
  features: [
    '30 day free trial',
    'Unlimited transcription',
    'Translation in 100+ languages'
  ]
};

export const ENTERPRISE_PLAN = {
  id: 'enterprise',
  name: 'Enterprise',
  currency: 'USD',
  priceInCents: 699,
  billedMonthly: true,
  description: '',
  image: <img src={enterprise} alt="enterprise"/>,
  features: [
    'Discounted rate for 25+ users',
    'Unlimited transcription',
    'Translation in 100+ languages'
  ]
};



// WEBPACK FOOTER //
// ./src/components/Plans/index.js